import React from 'react';
import { pure } from 'recompose';
import classNames from 'classnames';
import Icon from 'components/general/Icon/Icon';
import Button from 'components/general/Button/Button';
import DropdownMenu, { MenuAction } from 'components/general/DropdownMenu/DropdownMenu';
import withPopover from 'components/hoc/withPopover';
import RenderPropType from 'utils/ts/RenderPropType';

const ActionMenu: React.SFC<ActionMenuProps> = (props) => {
  const {
    isOpen,
    onClose,
    triggerProps,
    btnProps,
    title,
    actions,
    hideArrow,
    direction,
    className,
    category,
  } = props;

  const classes = classNames('action-menu', className, {
    'action-menu--right': direction === 'right',
  });

  return (
    <div className={classes}>
      <Button {...triggerProps} {...btnProps}>
        <span className="btn__pre-title">
          {category}
        </span>
        {typeof title === 'function' ? title(props) : title}
        {!hideArrow && (
          <Icon name="chevron-down" types={['push-left']} />
        )}
      </Button>
      <DropdownMenu
        isOpen={isOpen}
        onSelect={onClose}
        className="action-menu__dropdown"
        items={actions}
      />
    </div>
  );
};

export interface ActionMenuProps {
  title: string|RenderPropType;
  actions: MenuAction[];
  className?: string;
  direction?: 'left'|'right';
  hideArrow?: boolean;
  btnProps?: object;
  triggerProps?: object;
  isOpen?: boolean;
  category?: string;
  onSelect?();
  onClose?();
}

export default pure(withPopover(ActionMenu, { autoDismiss: true }));
